<div class="container-fluid white-space-wrap text-left pt-2" [attr.data-qa]="'two-factor-deny-modal'">
    <h2 class="msg-title text-left" [attr.data-qa]="'two-factor-deny-modal-title'">{{denyModalTitle || "Secure Your Account with Two-Step Verification"}}</h2>
    <p class="pt-3 msg-body" [attr.data-qa]="'two-factor-deny-modal-p'">{{denyModalMsg || "In order to continue, you must set up Two-Step Verification. This is an additional layer of security to protect your
      account."}}</p>
  <div class="row">
    <div class="col-xs-12 text-right pt-2">
      <button type="button" [attr.data-qa]="'two-factor-deny-modal-close'"[attr.data-qa]="'two-factor-deny-modal'" class="btn btn-default" (click)="close()" data-dismiss="modal">Cancel</button>
      <button type="button" [attr.data-qa]="'two-factor-deny-modal-go-btn'" class="btn btn-primary ml-2" (click)="continueToNavigate()">Go to Two-Step Verification</button>
    </div>
  </div>
</div>
